module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ISO 9001-2015.18f6c61d.png";